import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('isValidAccountNumber', /^[0-9]\d{4,16}$/);
